import { useSelector } from "react-redux";
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
} from "../../config/permissions";

export const usePermissionCheck = () => {
  const { user, userPermissions, isMainVendor } = useSelector((state) => state.user);
  
  // Helper functions for permission checking
  const canPerform = (module, action) => {
    if (!user) return false;
    return hasPermission(userPermissions, isMainVendor, module, action);
  };

  const canPerformAny = (module, actions = []) => {
    if (!user) return false;
    return hasAnyPermission(userPermissions, isMainVendor, module, actions);
  };

  const canPerformAll = (module, actions = []) => {
    if (!user) return false;
    return hasAllPermissions(userPermissions, isMainVendor, module, actions);
  };

  const rolesPermissions = {
    canViewRoles: () => canPerform("Roles_Permission", "Role_View"),
    canCreateRoles: () => canPerform("Roles_Permission", "Role_Create"),
    canEditRoles: () => canPerform("Roles_Permission", "Role_Edit"),
    canDeleteRoles: () => canPerform("Roles_Permission", "Role_Delete"),
    canManageTeam: () =>
      canPerformAny("Roles_Permission", ["Role_View", "Role_Create", "Role_Edit"]),
    canAccessRolesSection: () => canPerform("Roles_Permission", "Role_View"),
    hasFullRoleAccess: () =>
      user && (isMainVendor ||
      canPerformAll("Roles_Permission", ["Role_View", "Role_Create", "Role_Edit", "Role_Delete"])),
  };

  return {
    canPerform,
    canPerformAny,
    canPerformAll,
    isMainVendor,
    userPermissions,
    isAuthenticated: !!user,
    ...rolesPermissions,
  };
};
